import React from 'react';
import { duckify } from 'utils/duckify';
import { renderedSnippet } from 'ducks/webSnippets';

const SchoolContactInfo = ({ portalSummarySidebar, portalSummarySidebarHeader }) => (
  <div>
    { portalSummarySidebarHeader && <div dangerouslySetInnerHTML={{ __html: portalSummarySidebarHeader.body }} /> }
    { portalSummarySidebar && <div dangerouslySetInnerHTML={{ __html: portalSummarySidebar.body }} /> }
  </div>
);

const mapDucksToProps = () => ({
  portalSummarySidebarHeader: renderedSnippet('portal_summary_sidebar_header'),
  portalSummarySidebar: renderedSnippet('portal_summary_sidebar')
});


export default duckify(mapDucksToProps, () => ({}), () => ({}))(SchoolContactInfo);
